<!-- Label -->
<header class="fx-row x-start y-start gap-04">
  <label [for]="controlId()" [id]="controlId() + '-label'">
    <span bspk-txt="labels-small" color="on-surface-variant-01">{{ label() }}</span>
    @if (required()) {
      <span aria-hidden="true" bspk-txt="body-small">&nbsp;(Required)</span>
    }
  </label>

  <!-- Trailing element -->
  <ng-content select="[data-label-trailing]" />
</header>

<!-- Control -->
<ng-content />

@if (errorMessage()) {
  <!-- Error text -->
  <bspk-inline-alert variant="error">
    <span [innerHtml]="errorMessage()"></span>
  </bspk-inline-alert>
}
@else if (helperText()) {
  <!-- Helper text -->
  <span bspk-txt="body-small">{{ helperText() }}</span>
}

